/* 

----- Domain Detection -----
Helper module to handle URL processing.

Current functionality:
1. Cross domain fetch, checks whether the requested domain is from another domain.


*/


// ----- Dependancies -----
// https://www.npmjs.com/package/psl/v/1.1.33?activeTab=readme for parsing url.
import psl from 'psl';
// IPV4 Regexp.
const regexIPV4 = /^(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
// IPV6 Regexp.
const regexIPV6 = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;

// Check whether this is a cross-origin request.
function isCrossOrigin(requestedUrl) {
    // Check to make sure request url is a URL constructor.
    if (requestedUrl instanceof URL != URL) {
        requestedUrl = new URL(requestedUrl, window.location.origin);
    }
    // Get origin.
    const domain = requestedUrl.hostname;
    // Check whether domain is IP as psl library doesn't support.
    const isDomainIP = isIP(domain);
    // Parse requested domain.
    const requestDomainParsed = (isDomainIP ? domain : psl.parse(domain));
    // Current Url.
    const currentDomain = self.location.hostname;
    // Check if current domain is IP.
    const isCurrentDomainIp = isIP(currentDomain);
    // Parse current damain.
    const currentDomainParsed = (isCurrentDomainIp ? currentDomainParsed : psl.parse(currentDomain));
    // The psl library is to designed to parse domain names not IP addresses, sd will have to handle those seperately.
    if (isDomainIP || isCurrentDomainIp) {
        return !domainMatch(domain, currentDomain);
    } else {
        // If either is not listed ( i.e localhost ) then fallback to input for check.
        const request = (!requestDomainParsed['listed'] ? requestDomainParsed['input'] : requestDomainParsed['domain']);
        const current = (!currentDomainParsed['listed'] ? currentDomainParsed['input'] : currentDomainParsed['domain']);
        return !domainMatch(request, current);
    }
}

// Check whether requested domain matches the current domain.
function domainMatch(requestDomain, currentDomain) {
    if (requestDomain == currentDomain) {
        return true;
    } else {
        return false;
    }
}

// Check whether domain is an ip.
function isIP(domain) {
    // Test against IPV4.
    let check = regexIPV4.test(domain);
    if (!check) {
        // Test against IPV6.
        check = regexIPV6.test(domain);
    }
    return check;
}

var component = {
    isCrossOrigin: (url) => {
        return isCrossOrigin(url);
    }
}

export { component };